<template>
  <div class="container">
    <el-row :gutter="20">
      <el-col :span="10">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>小程序端</span>
          </div>
          <div>
            <el-alert
              title="请使用微信小程序端"
              type="info"
              description="请扫描下方二维码或在微信中搜索“为众电气”小程序进行使用。"
              show-icon
              :closable="false">
            </el-alert>
            <div style="margin-top: 20px; text-align: center;">
             <img src="../../../static/images/wechatqr.jpg" width="200" height="200" alt="小程序二维码">
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>

export default {}
</script>
<style>
.box-card {
  width: 480px;
}
</style>